import { SVGAssets } from '@business/assets/vectors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

interface UploadProgressModalProps {
  isOpen: boolean;
  current: number;
  total: number;
  onClose: () => void;
}

export const UploadProgressModal: React.FC<UploadProgressModalProps> = ({
  isOpen,
  current,
  total,
  onClose
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const progressPercentage =
    total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="fixed inset-0 bg-[#353535] bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white rounded-lg p-6 w-96 shadow-xl confirmation-box-style">
        <div className="flex justify-between items-center mb-6 border-b">
          <h3 className="text-lg font-semibold">
            {t('dashboard.uploadFiles')}
          </h3>
          <Button
            btnStyle="link"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            data-testid="close-button">
            <SVGAssets.CloseIconGray className="w-5 h-4 text-gray-400" />
          </Button>
        </div>

        <div className="mb-6">
          <p className="text-center text-sm font-bold mb-4">
            {t('dashboard.imagesBeingUploaded')}
          </p>

          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-3">
            <div
              className="bg-[#49712B] h-2.5 rounded-full transition-all duration-300"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>

          <p className="text-center text-xs text-gray-600">
            {t('dashboard.imagesUploadedCount', { current, total })}
          </p>
        </div>

        <div className="flex justify-end">
          <Button
            btnStyle="primary"
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-md">
            {t('cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
};
